import i18n from 'i18next';

/**
 * «20.11 · пн» — a competition day named by its date and weekday, never by its
 * number (organiser, 2 Nov 2026: «дати замість номерів» — the shooting's day,
 * then the bouts' days, read as the calendar reads). Null without a date: the
 * caller falls back to «День N».
 *
 * @param {?string} ymd «2026-11-20» or an ISO time
 * @param {?string} language the page's language — the weekday's
 */
const dateWithWeekday = (ymd, language) => {
    if ('string' !== typeof ymd || ymd.length < 10) {
        return null;
    }
    const [y, m, d] = ymd.slice(0, 10).split('-').map(Number);
    const date = new Date(Date.UTC(y, m - 1, d, 12));
    const lang = String(language || i18n.language || 'ua').startsWith('en') ? 'en-GB' : 'uk-UA';
    const weekday = date.toLocaleDateString(lang, { weekday: 'short', timeZone: 'UTC' });

    return `${String(d).padStart(2, '0')}.${String(m).padStart(2, '0')} · ${weekday}`;
};

export default dateWithWeekday;
